import { LoyaltyOffersHubUrgencyType } from 'loyalty/lib/loyaltyOffersHub/constants'
import type { LoyaltyOffersHubOffer } from 'loyalty/lib/loyaltyOffersHub/types'
import { formatTimeRemaining } from 'loyalty/statusMatch/formatTimeRemaining'
import Label from 'LuxKit/Label/Label'
import UrgencyLabel from 'LuxKit/Label/UrgencyLabel'
import { useIntl } from 'react-intl'

interface Props {
  offer: LoyaltyOffersHubOffer
}

function LoyaltyOffersHubOfferLabel({ offer }: Props) {
  const intl = useIntl()

  if (offer.urgencyType === LoyaltyOffersHubUrgencyType.LIMITED_TIME) {
    return <Label kind="primary" variant="highlight">
      {intl.formatMessage({
        id: 'uOqZ19Y3-3tkUrH6qVPX',
        defaultMessage: 'Limited time offer',
        description: 'Urgency label for limited-time Societe offers on offer cards',
      })}
    </Label>
  }

  if (offer.urgencyType === LoyaltyOffersHubUrgencyType.COUNTDOWN) {
    const countdownLabel = formatTimeRemaining(offer.endAt, intl, { variant: 'ends-in-prefix' })

    return countdownLabel ? <UrgencyLabel variant="speed">{countdownLabel}</UrgencyLabel> : null
  }

  return null
}

export default LoyaltyOffersHubOfferLabel
